export const toggleModal = (flag, modal) =>{
        return {
            type: 'TOGGLE_MODAL',
            flag,
            modal
        }
};

export const determineScreenSize = (isTabletOrMobile) => {
    return {
        type: 'CHECK_IF_MOBILE_SIZE',
        isTabletOrMobile: isTabletOrMobile
    }
}
